import 'whatwg-fetch';
import { fetchGet, rootApi, host, fetchPost } from '../helpers/api';
import { getToken } from '../helpers/common';

const systemApi = `${rootApi}/system`;

export const loadGraphColors = () => fetchGet('/graph-colors.json');

export const login = (credentials, callback) => {
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState === 4) {
      callback(this.status, {
        token: xhttp.getResponseHeader('Authorization'),
        userId: xhttp.getResponseHeader('X-User')
      }, this.responseText);
    }
  };
  xhttp.open("POST", `${host}/login`, true);
  xhttp.setRequestHeader("Content-type", "application/json");
  xhttp.send(JSON.stringify(credentials));
}

export const logout = () => fetchPost(`${host}/logout`, {});

export const refreshToken = (callback) => {
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState === 4) {
      callback(this.status, {
        token: xhttp.getResponseHeader('Authorization'),
        userId: xhttp.getResponseHeader('X-User')
      }, this.responseText);
    }
  };
  xhttp.open("GET", `${systemApi}/refreshToken`, true);
  xhttp.setRequestHeader("Content-type", "application/json");
  xhttp.setRequestHeader('Authorization', getToken());
  xhttp.send(JSON.stringify("Success"));
};

export const loadUserData = email => fetchGet(`${systemApi}/user-data/${email}`);

export const loadAdminUiAccess = () => fetchGet('/admin-ui-access.json');

export const loadUserUiAccess = () => fetchGet('/user-ui-access.json');

export const loadSubUserUiAccess = () => fetchGet('/subuser-ui-access.json');

export const requestOTPMail = email => fetchPost(`${systemApi}/forget-password/${email}`, {});

export const resetPassword = (email, otp, password) => fetchPost(`${systemApi}/reset-password`, { email, otp, password });